export default {
  "accountCreate.failure": "Accept invitation failed",
  "accountCreate.reset": "Accept Invitation",
  "accountCreate.header": "Accept Invitation",
  "accountCreate.password": "New Password",
};
